import { c as _c } from "react/compiler-runtime";
import { COUNTRIES, VAULT_DOT_SEPARATOR, type VaultFormData } from '@onefootprint/core';
import { IcoBuilding24 } from '@onefootprint/icons';
import type { DataIdentifier, Locale } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type ResidentialAddressProps = {
  locale: Locale;
  residentialAddressCountries?: string[];
  disabledDis: DataIdentifier[];
};
export const ResidentialAddress = t0 => {
  const $ = _c(130);
  const {
    locale,
    residentialAddressCountries,
    disabledDis
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== disabledDis || $[2] !== locale || $[3] !== residentialAddressCountries || $[4] !== t) {
    const filteredCountries = residentialAddressCountries?.length ? COUNTRIES.filter(c => residentialAddressCountries.includes(c.value)) : COUNTRIES;
    t12 = "flex flex-col gap-4";
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <div className="flex gap-1 items-center"><IcoBuilding24 color="primary" /><span className="text-label-2 text-primary">Your address</span></div>;
      $[18] = t13;
    } else {
      t13 = $[18];
    }
    T0 = Form.AddressLines;
    t3 = "id";
    t4 = VAULT_DOT_SEPARATOR;
    t5 = true;
    let t14;
    if ($[19] !== disabledDis) {
      t14 = disabledDis.includes("id.country");
      $[19] = disabledDis;
      $[20] = t14;
    } else {
      t14 = $[20];
    }
    let t15;
    if ($[21] !== disabledDis) {
      t15 = disabledDis.includes("id.address_line1");
      $[21] = disabledDis;
      $[22] = t15;
    } else {
      t15 = $[22];
    }
    let t16;
    if ($[23] !== disabledDis) {
      t16 = disabledDis.includes("id.address_line2");
      $[23] = disabledDis;
      $[24] = t16;
    } else {
      t16 = $[24];
    }
    let t17;
    if ($[25] !== disabledDis) {
      t17 = disabledDis.includes("id.city");
      $[25] = disabledDis;
      $[26] = t17;
    } else {
      t17 = $[26];
    }
    let t18;
    if ($[27] !== disabledDis) {
      t18 = disabledDis.includes("id.state");
      $[27] = disabledDis;
      $[28] = t18;
    } else {
      t18 = $[28];
    }
    let t19;
    if ($[29] !== disabledDis) {
      t19 = disabledDis.includes("id.zip");
      $[29] = disabledDis;
      $[30] = t19;
    } else {
      t19 = $[30];
    }
    if ($[31] !== t14 || $[32] !== t15 || $[33] !== t16 || $[34] !== t17 || $[35] !== t18 || $[36] !== t19) {
      t6 = {
        country: t14,
        addressLine1: t15,
        addressLine2: t16,
        city: t17,
        state: t18,
        zip: t19
      };
      $[31] = t14;
      $[32] = t15;
      $[33] = t16;
      $[34] = t17;
      $[35] = t18;
      $[36] = t19;
      $[37] = t6;
    } else {
      t6 = $[37];
    }
    if ($[38] !== locale) {
      t7 = {
        locale
      };
      $[38] = locale;
      $[39] = t7;
    } else {
      t7 = $[39];
    }
    t8 = filteredCountries;
    let t20;
    if ($[40] !== t) {
      t20 = t(_temp);
      $[40] = t;
      $[41] = t20;
    } else {
      t20 = $[41];
    }
    let t21;
    if ($[42] !== t) {
      t21 = t(_temp2);
      $[42] = t;
      $[43] = t21;
    } else {
      t21 = $[43];
    }
    let t22;
    if ($[44] !== t) {
      t22 = t(_temp3);
      $[44] = t;
      $[45] = t22;
    } else {
      t22 = $[45];
    }
    let t23;
    if ($[46] !== t) {
      t23 = t(_temp4);
      $[46] = t;
      $[47] = t23;
    } else {
      t23 = $[47];
    }
    let t24;
    if ($[48] !== t) {
      t24 = t(_temp5);
      $[48] = t;
      $[49] = t24;
    } else {
      t24 = $[49];
    }
    let t25;
    if ($[50] !== t) {
      t25 = t(_temp6);
      $[50] = t;
      $[51] = t25;
    } else {
      t25 = $[51];
    }
    let t26;
    if ($[52] !== t) {
      t26 = t(_temp7);
      $[52] = t;
      $[53] = t26;
    } else {
      t26 = $[53];
    }
    let t27;
    if ($[54] !== t) {
      t27 = t(_temp8);
      $[54] = t;
      $[55] = t27;
    } else {
      t27 = $[55];
    }
    let t28;
    if ($[56] !== t) {
      t28 = t(_temp9);
      $[56] = t;
      $[57] = t28;
    } else {
      t28 = $[57];
    }
    if ($[58] !== t20 || $[59] !== t21 || $[60] !== t22 || $[61] !== t23 || $[62] !== t24 || $[63] !== t25 || $[64] !== t26 || $[65] !== t27 || $[66] !== t28) {
      t9 = {
        country: t20,
        addressLine1: t21,
        addressLine1International: t22,
        addressLine2: t23,
        addressLine2International: t24,
        city: t25,
        state: t26,
        stateInternational: t27,
        zip: t28
      };
      $[58] = t20;
      $[59] = t21;
      $[60] = t22;
      $[61] = t23;
      $[62] = t24;
      $[63] = t25;
      $[64] = t26;
      $[65] = t27;
      $[66] = t28;
      $[67] = t9;
    } else {
      t9 = $[67];
    }
    let t29;
    if ($[68] !== t) {
      t29 = t(_temp10);
      $[68] = t;
      $[69] = t29;
    } else {
      t29 = $[69];
    }
    let t30;
    if ($[70] !== t) {
      t30 = t(_temp11);
      $[70] = t;
      $[71] = t30;
    } else {
      t30 = $[71];
    }
    let t31;
    if ($[72] !== t) {
      t31 = t(_temp12);
      $[72] = t;
      $[73] = t31;
    } else {
      t31 = $[73];
    }
    let t32;
    if ($[74] !== t) {
      t32 = t(_temp13);
      $[74] = t;
      $[75] = t32;
    } else {
      t32 = $[75];
    }
    let t33;
    if ($[76] !== t) {
      t33 = t(_temp14);
      $[76] = t;
      $[77] = t33;
    } else {
      t33 = $[77];
    }
    let t34;
    if ($[78] !== t) {
      t34 = t(_temp15);
      $[78] = t;
      $[79] = t34;
    } else {
      t34 = $[79];
    }
    let t35;
    if ($[80] !== t) {
      t35 = t(_temp16);
      $[80] = t;
      $[81] = t35;
    } else {
      t35 = $[81];
    }
    let t36;
    if ($[82] !== t) {
      t36 = t(_temp17);
      $[82] = t;
      $[83] = t36;
    } else {
      t36 = $[83];
    }
    if ($[84] !== t29 || $[85] !== t30 || $[86] !== t31 || $[87] !== t32 || $[88] !== t33 || $[89] !== t34 || $[90] !== t35 || $[91] !== t36) {
      t10 = {
        country: t29,
        addressLine1: t30,
        addressLine2: t31,
        addressLine2International: t32,
        city: t33,
        state: t34,
        stateInternational: t35,
        zip: t36
      };
      $[84] = t29;
      $[85] = t30;
      $[86] = t31;
      $[87] = t32;
      $[88] = t33;
      $[89] = t34;
      $[90] = t35;
      $[91] = t36;
      $[92] = t10;
    } else {
      t10 = $[92];
    }
    let t37;
    if ($[93] !== t) {
      t37 = t(_temp18);
      $[93] = t;
      $[94] = t37;
    } else {
      t37 = $[94];
    }
    let t38;
    if ($[95] !== t) {
      t38 = t(_temp19);
      $[95] = t;
      $[96] = t38;
    } else {
      t38 = $[96];
    }
    let t39;
    if ($[97] !== t) {
      t39 = t(_temp20);
      $[97] = t;
      $[98] = t39;
    } else {
      t39 = $[98];
    }
    let t40;
    if ($[99] !== t) {
      t40 = t(_temp21);
      $[99] = t;
      $[100] = t40;
    } else {
      t40 = $[100];
    }
    let t41;
    if ($[101] !== t) {
      t41 = t(_temp22);
      $[101] = t;
      $[102] = t41;
    } else {
      t41 = $[102];
    }
    let t42;
    if ($[103] !== t) {
      t42 = t(_temp23);
      $[103] = t;
      $[104] = t42;
    } else {
      t42 = $[104];
    }
    if ($[105] !== t37 || $[106] !== t38 || $[107] !== t39 || $[108] !== t40 || $[109] !== t41 || $[110] !== t42) {
      t11 = {
        country: t37,
        addressLine1: t38,
        addressLine2: t39,
        city: t40,
        state: t41,
        zip: t42
      };
      $[105] = t37;
      $[106] = t38;
      $[107] = t39;
      $[108] = t40;
      $[109] = t41;
      $[110] = t42;
      $[111] = t11;
    } else {
      t11 = $[111];
    }
    t2 = t(_temp24, {
      countryName: filteredCountries[0]?.label
    });
    $[1] = disabledDis;
    $[2] = locale;
    $[3] = residentialAddressCountries;
    $[4] = t;
    $[5] = T0;
    $[6] = t10;
    $[7] = t11;
    $[8] = t12;
    $[9] = t13;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    T0 = $[5];
    t10 = $[6];
    t11 = $[7];
    t12 = $[8];
    t13 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  let t14;
  if ($[112] !== t2) {
    t14 = {
      countryDisabled: t2
    };
    $[112] = t2;
    $[113] = t14;
  } else {
    t14 = $[113];
  }
  let t15;
  if ($[114] !== T0 || $[115] !== t10 || $[116] !== t11 || $[117] !== t14 || $[118] !== t3 || $[119] !== t4 || $[120] !== t5 || $[121] !== t6 || $[122] !== t7 || $[123] !== t8 || $[124] !== t9) {
    t15 = <T0 prefix={t3} vaultSeparator={t4} required={t5} disabled={t6} l10n={t7} countries={t8} labels={t9} placeholders={t10} errors={t11} hints={t14} />;
    $[114] = T0;
    $[115] = t10;
    $[116] = t11;
    $[117] = t14;
    $[118] = t3;
    $[119] = t4;
    $[120] = t5;
    $[121] = t6;
    $[122] = t7;
    $[123] = t8;
    $[124] = t9;
    $[125] = t15;
  } else {
    t15 = $[125];
  }
  let t16;
  if ($[126] !== t12 || $[127] !== t13 || $[128] !== t15) {
    t16 = <div className={t12}>{t13}{t15}</div>;
    $[126] = t12;
    $[127] = t13;
    $[128] = t15;
    $[129] = t16;
  } else {
    t16 = $[129];
  }
  return t16;
};
function _temp($) {
  return $.fields.address.country.label;
}
function _temp2($_0) {
  return $_0.fields.address.addressLine1.label;
}
function _temp3($_1) {
  return $_1.fields.address.addressLine1.internationalLabel;
}
function _temp4($_2) {
  return $_2.fields.address.addressLine2.label;
}
function _temp5($_3) {
  return $_3.fields.address.addressLine2.internationalLabel;
}
function _temp6($_4) {
  return $_4.fields.address.city.label;
}
function _temp7($_5) {
  return $_5.fields.address.state.label;
}
function _temp8($_6) {
  return $_6.fields.address.state.internationalLabel;
}
function _temp9($_7) {
  return $_7.fields.address.zip.label;
}
function _temp10($_8) {
  return $_8.fields.address.country.placeholder;
}
function _temp11($_9) {
  return $_9.fields.address.addressLine1.placeholder;
}
function _temp12($_10) {
  return $_10.fields.address.addressLine2.placeholder;
}
function _temp13($_11) {
  return $_11.fields.address.addressLine2.internationalPlaceholder;
}
function _temp14($_12) {
  return $_12.fields.address.city.placeholder;
}
function _temp15($_13) {
  return $_13.fields.address.state.placeholder;
}
function _temp16($_14) {
  return $_14.fields.address.state.internationalPlaceholder;
}
function _temp17($_15) {
  return $_15.fields.address.zip.placeholder;
}
function _temp18($_16) {
  return $_16.fields.address.country.error;
}
function _temp19($_17) {
  return $_17.fields.address.addressLine1.error;
}
function _temp20($_18) {
  return $_18.fields.address.addressLine2.error;
}
function _temp21($_19) {
  return $_19.fields.address.city.error;
}
function _temp22($_20) {
  return $_20.fields.address.state.error;
}
function _temp23($_21) {
  return $_21.fields.address.zip.error;
}
function _temp24($_22) {
  return $_22.fields.address.country.disabledHint;
}